/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable react/prop-types,no-undef */
import React from 'react';
import { withRouter } from 'react-router-dom';
import cn from 'clsx';
import T from 'i18n-react';
import { Box, Button, Typography, useMediaQuery } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { ALI_REGISTRATION_LANG_PATH } from 'shared/path';
import { ALI_LOGIN_PATH } from 'shared/routes';
import { getCookie, setLanguageLocale } from 'util/icwUtility';
import Announcement from 'views/Login/components/Announcement';
import loginStyles from 'assets/jss/icw/loginStyle';
import icwLogo from 'assets/img/icw-logo.png';
import qmasLogoWhite from 'assets/img/qmas_logo_white_full.png';
import { useTheme } from '@material-ui/styles';
import icwSmallLogo from 'assets/img/qmas_logo_small_words.png';
import alibabaLogo from 'assets/img/alibaba-logo.png';
import RegistrationFormContainer from './RegistrationFormContainer';
import rClasses from './Registration.module.scss'

// TODO: try to optimize => do not load from init
setLanguageLocale(T, [ALI_REGISTRATION_LANG_PATH]);

const Registration = ({
  history,
  match: {
    params: { locale },
  },
  classes,
  match,
  ...rest
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box className={classes.login}>
      {getCookie('qmas_important_notice') && <Announcement />}
      <Box
        display='flex'
        height='100%'
        sx={{
          flexDirection: {
            xs: 'column-reverse',
            md: 'row',
          },
        }}>
        <Box className={cn(classes.registerBackgroundContainer, classes.registerAlibabaBackgroundContainer)}>
          {!isMobile && (
            <img
              width={160}
              height={70}
              style={{ position: 'absolute', top: 20, left: 20 }}
              src={qmasLogoWhite}
              alt='qmasLogoWhite'
            />
          )}
          <Typography className={classes.loginRightTitle}>{T.translate('login.login')}!</Typography>
          {isMobile ? (
            <Typography className={classes.loginRightSubTitle}>
              {T.translate('general.signUpLeftSubTitlePart1')}
              <span
                onClick={() =>
                  history.push({
                    pathname: `/${locale}${ALI_LOGIN_PATH}`,
                  })
                }
                style={{
                  color: '#B0D400',
                  textDecoration: 'underline',
                }}>
                {T.translate('general.signUpLeftSubTitlePart2')}
              </span>
              {T.translate('general.signUpLeftSubTitlePart3')}
            </Typography>
          ) : (
            <Typography className={classes.loginRightSubTitle}>
              {T.translate('general.signUpLeftSubTitle')}
            </Typography>
          )}
          <Button
            onClick={() =>
              history.push({
                pathname: `/${match.params.locale}${ALI_LOGIN_PATH}`,
              })
            }
            variant='outlined'
            className={classes.loginRightButton}>
            {T.translate('general.login')}
          </Button>
        </Box>
        <Box
          display='flex'
          flexDirection='column'
          align='center'
          alignItems='center'
          mt='10px'
          flex={0.7}
          sx={{
            justifyContent: {
              xs: 'flex-start',
              md: 'flex-start',
            },
          }}>
          {isMobile && (
            <Box
              sx={{
                alignSelf: {
                  xs: 'center',
                  md: 'flex-start',
                },
                ml: {
                  xs: 0,
                  md: '20px',
                },
              }}>
              <a href='/'>
                <img className={classes.icon} src={icwSmallLogo} alt='logo' />
              </a>
            </Box>
          )}
          <Box className={rClasses.alibabaLogo}>
            <a href='/'>
              <img  src={alibabaLogo} alt='logo' />
            </a>
          </Box>
          <Box
            sx={{
              minWidth: '25%',
              maxWidth: {
                xs: '85%',
                md: '75%',
              },
            }}>
            <RegistrationFormContainer
              locale={match.params.locale}
              history={history}
              isMobile={isMobile}
              {...rest}
            />
          </Box>
        </Box>
      </Box>
      {!isMobile && (
        <Box
          style={{
            position: 'absolute',
            bottom: 25,
            right: 30,
          }}>
          <Typography style={{ fontSize: 11, fontFamily: 'Montserrat', fontWeight: 500 }}>
            Powered by
          </Typography>
          <img style={{ width: 85, height: 50 }} src={icwLogo} alt='icwLogo' />
        </Box>
      )}
    </Box>
  );
};

export default withRouter(withStyles(loginStyles)(Registration));
